// extracted by mini-css-extract-plugin
export default {"icon":"APCopyIcon_icon__106eY"};